export const ru = {
  'calls-history-title': 'История звонков',
  'collect-call': 'Собрать звонок',
  'stub-description': 'Здесь будет отображаться список ваших прошедших звонков',
  'stub-title': 'У вас нет звонков',
  'stub-title-with-records': 'У вас нет звонков с записями'
}
